export const conLog = (...args: any[]) => {
    // show source file and line number
    if (import.meta.env.DEV) {
        console.log(...args);
    }
};
